import { useCallback } from 'react';
import { LucideBuilding, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import React from 'react';
import { useOrganization } from 'src/context/OrganizationContext';

export const OrganizationSelector = () => {
  const {
    organizationId,
    isResolved,
    availableOrganizations,
    currentOrganization,
    requestOrganizationSwitch,
    setOrganizationId,
  } = useOrganization();

  const handleSelectOrg = useCallback(
    (orgId: string) => {
      requestOrganizationSwitch(orgId, () => {
        setOrganizationId(orgId);
      });
    },
    [requestOrganizationSwitch, setOrganizationId],
  );

  // Don't show selector until organization is resolved
  if (!isResolved) {
    return null;
  }

  // Only show selector if user has multiple organizations
  if (availableOrganizations.length < 2) {
    return null;
  }

  const selectedOrgName = currentOrganization?.name || 'Select organization';

  return (
    <div className="flex flex-col w-full">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex flex-row text-text-light rounded-lg px-4 py-3 w-full justify-between items-center hover:bg-slate-50 active:bg-slate-100 transition-colors focus:outline-none touch-manipulation">
          <div className="flex items-center gap-4 min-w-0">
            <LucideBuilding className="h-5 w-5 text-text-light flex-shrink-0" />
            <div className="truncate text-base max-w-[160px] font-medium">{selectedOrgName}</div>
          </div>
          <ChevronDown className="h-5 w-5 text-slate-400 flex-shrink-0 ml-1" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[240px] z-50">
          {availableOrganizations.map((org, index) => (
            <React.Fragment key={org._id}>
              {index > 0 && <DropdownMenuSeparator />}
              <DropdownMenuItem
                onClick={() => handleSelectOrg(org._id)}
                className={`text-base py-3 px-4 ${organizationId === org._id ? 'bg-slate-100 font-medium' : ''}`}
              >
                <div className="truncate">{org.name}</div>
              </DropdownMenuItem>
            </React.Fragment>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
